import { FaqData, FaqGroupStatus } from "entities/faqs/types";
import { getChipColor } from "modules/brands/utils";
import Chip from "shared/components/Chip";
import { Column } from "shared/components/DragNDropTable/helpers";
import DropdownList, {
  DropdownListItemProps,
} from "shared/components/DropdownList";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { ArrowForwardIcon } from "shared/theme/icons/ArrowForwardIcon";
import { StyledActionsWrapper } from "./styled";
import { ColumnsProps } from "./types";

const renderStatusCell = (item: FaqData) => {
  const isActive = item.status === FaqGroupStatus.Active;
  const color = getChipColor(isActive);
  const title = Boolean(isActive) ? "Active" : "Inactive";

  return <Chip title={title} bgColor={color} />;
};

export const getPageModulesColumns = ({
  faqItemDrawer,
  handlePublishStatus,
  handleOpenDeleteModal,
  handleOpenChangeGroupModal,
  readOnly,
}: ColumnsProps): Column<FaqData>[] => {
  const renderActions = (faqItem: FaqData) => {
    if (readOnly) {
      return (
        <StyledActionsWrapper
          onClick={() => faqItemDrawer.openDrawer(faqItem.id)}
        >
          <ArrowForwardIcon color={COLOR_PRIMARY_MAIN} />
        </StyledActionsWrapper>
      );
    }

    const isActive = faqItem.status === FaqGroupStatus.Active;
    const statusTitle = isActive ? "Unpublish" : "Publish";

    let items: DropdownListItemProps[] = [
      {
        title: "Edit",
        style: "normal",
        onClick: () => faqItemDrawer.openDrawer(faqItem.id),
      },
      {
        title: statusTitle,
        style: "normal",
        onClick: () => {
          handlePublishStatus({
            ...faqItem,
            status:
              faqItem.status === FaqGroupStatus.Active
                ? FaqGroupStatus.Draft
                : FaqGroupStatus.Active,
          });
        },
      },
      {
        title: "Change group",
        style: "normal",
        onClick: () => handleOpenChangeGroupModal(faqItem),
      },
      {
        title: "Delete",
        style: "remove",
        onClick: () => handleOpenDeleteModal(faqItem),
      },
    ];

    return <DropdownList items={items} />;
  };

  return [
    {
      headerName: "Question",
      width: "70%",
      renderCell: (item: FaqData) => item.question,
    },
    {
      headerName: "Status",
      width: "30%",
      align: "left",
      headerAlign: "left",
      renderCell: renderStatusCell,
    },
    {
      headerName: "",
      width: "10%",
      align: "right",
      headerAlign: "right",
      renderCell: (item: FaqData) => {
        return renderActions(item);
      },
    },
  ];
};
